import { useContext } from 'react';
import { BlockKitContext } from '../../contexts/context';
export var useEventsManager = function useEventsManager() {
  var ctx = useContext(BlockKitContext);
  if (!ctx) {
    throw new Error('useEventsManager must be used within a BlockKitContext.Provider');
  }
  return ctx.eventManager;
};